<template>
  <v-card class="rounded-card card-shadow">
    <v-tabs v-model="tab">
      <v-tab>Avaliações</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card
          class="rounded-card"
          flat
        >
          <v-card-text>
            <px-minha-empresa-tab-avaliacoes :empresa="empresa"/>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import MinhaEmpresaTabAvaliacoes from './MinhaEmpresaTabAvaliacoes.vue';

export default {
  props: {
    empresa: Object,
  },
  data() {
    return {
      tab: null,
    };
  },
  components: {
    pxMinhaEmpresaTabAvaliacoes: MinhaEmpresaTabAvaliacoes,
  },
};
</script>
